/* Custom Testimonials carousel — powered by Embla (assets/embla-carousel.js, UMD global `EmblaCarousel`). */

(function () {
  function initCarousel(root) {
    if (root.dataset.emblaReady || typeof EmblaCarousel === 'undefined') return;

    var viewport = root.querySelector('.custom-testimonials__viewport');
    var prevButton = root.querySelector('[data-testimonials-prev]');
    var nextButton = root.querySelector('[data-testimonials-next]');
    var dotsContainer = root.querySelector('[data-testimonials-dots]');
    if (!viewport) return;

    var embla = EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
      breakpoints: {
        // Wide desktop: all cards fit, carousel deactivates (controls hidden in CSS)
        '(min-width: 1780px)': { active: false },
      },
    });

    var dots = [];

    function buildDots() {
      dotsContainer.innerHTML = '';
      dots = embla.scrollSnapList().map(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'custom-testimonials__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.addEventListener('click', function () {
          embla.scrollTo(index);
        });
        dotsContainer.appendChild(dot);
        return dot;
      });
    }

    function update() {
      var selected = embla.selectedScrollSnap();
      dots.forEach(function (dot, index) {
        dot.classList.toggle('custom-testimonials__dot--active', index === selected);
      });
      prevButton.disabled = !embla.canScrollPrev();
      nextButton.disabled = !embla.canScrollNext();
    }

    prevButton.addEventListener('click', function () {
      embla.scrollPrev();
    });
    nextButton.addEventListener('click', function () {
      embla.scrollNext();
    });

    embla.on('select', update);
    embla.on('reInit', function () {
      buildDots();
      update();
    });

    buildDots();
    update();
    root.dataset.emblaReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
